import { Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NxiRestService } from '../services/NXI-Rest.service';
import { IAuthorizationService } from '@pershing/pershing-core';

declare global {
    interface Window { netxinvestorNs: any; }
}

@Component({
    selector: 'nxi-biometric-auth',
    template: ''
})

export class BiometricAuthComponent {

    isBiometricPromptReq: boolean = false;
    isBiometricAuthEntitled: boolean = false;
    isBiometricSupportDev: boolean = false;
    touchID: any;
    isThemeSet: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private nxiRestService: NxiRestService,
        private authService: IAuthorizationService) {
        this.isBiometricAuthEntitled = this.authService.isEntitled('BIOMETRIC_AUTHENTICATION');
        // Rest service call to get the biometric related values
        let queryParams: Params = this.route.snapshot.queryParams;
        this.nxiRestService.getNxiPreLoginRestResponse('init', queryParams).subscribe(
            response => {
                this.isBiometricPromptReq = response.isBiometricPromptReq;
                this.isBiometricSupportDev = response.isBiometricSupportDev;
                if (window.location.href.includes('/login')) {
                    this.isThemeSet = true;
                }
                if (!!this.isBiometricSupportDev) {
                    this.setTouchID();
                }
                if (!!this.isBiometricPromptReq) {
                    this.touchPrmptRedirect();
                }
                if (!!this.isBiometricSupportDev) {
                    let checkExist = setInterval(() => {
                        if (document.querySelectorAll('.prlg-LoginBox_Continuebtn.dijitButton.dijitButtonDisabled .dijitButtonNode').length) {
                            console.log('Button Found!!');
                            clearInterval(checkExist);
                            if (this.isThemeSet) {
                                this.touchDeviceThemeSet();
                            }
                        }
                    }, 100);
                    setTimeout(() => { clearInterval(checkExist); }, 20000);
                }
            }, error => {
                console.log(error);
            }
        );
    }

    // Url passed to mobile with param to decide TouchId Prompt required or not
    touchPrmptRedirect(): void {
        let url = 'touchID://isTouchIdPromptRequired=false';
        if (!!this.isBiometricAuthEntitled) {
            url = 'touchID://isTouchIdPromptRequired=true';
        }
        window.location.href = url;
        let queryParams: Params = this.route.snapshot.queryParams;
        this.nxiRestService.getNxiPreLoginRestResponse('setBioAuthPrompt', queryParams).subscribe(
            response => { if (response) { console.log("success"); } }
           
        );
    }

    // To pass the colorCode of the login button.
    // Element extracted based on class and computed styles picked from the element
    touchDeviceThemeSet(): void {
        let tmpContinueBtn = document.querySelectorAll('.prlg-LoginBox_Continuebtn.dijitButton.dijitButtonDisabled .dijitButtonNode');
        if (!!tmpContinueBtn && tmpContinueBtn.length > 0) {
            let computedStyle = window.getComputedStyle(tmpContinueBtn[0]);
            let btnColor = computedStyle.getPropertyValue('background-color');
            let btnTextColor = computedStyle.getPropertyValue('color');
            let colorCode = 'btnColor=' + this.convertRGBToHex(btnColor) + '&btnTextColor=' + this.convertRGBToHex(btnTextColor);
            window.location.href = 'touchID://isTouchIdEnabledForPreLogin=true&' + colorCode;
        }
    }

    // To convert the RGB computed style to Hex style
    convertRGBToHex(rgbStr: string): string {
        let hexStr = rgbStr.split('(')[1].split(')')[0];
        let hexStrs = hexStr.split(',');
        let convStr = '';
        hexStrs.forEach(element => {
            let convHex = parseInt(element, 10).toString(16);
            convHex = (convHex.length === 1) ? '0' + convHex : convHex;
            convStr = convStr + convHex;
        });
        return convStr;
    }

    setTouchID() {
        let require: any = window['require'];
        window.netxinvestorNs = window.netxinvestorNs || {};
        window.netxinvestorNs.rememberMyDevice = (fingerPrint, hashedFingerPrint) => {
            require(['nxi/widgets/login2/TouchID'],
                (TouchID) => {
                    this.touchID = new TouchID({ 'fingerPrint': fingerPrint, 'hashedFingerPrint': hashedFingerPrint });
                }
            );
        };
    }
}
